exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".I1ryk9yJC7mUvV6AfmVTq ._3EFWuAYBkNYL3V4Bjyvlnh{border:2px solid #e0e0e0;border-radius:50%;display:block;margin:0 auto;background:#fff;object-fit:cover}@media screen and (min-width: 1000px) and (min-height: 680px) and (max-height: 890px){.I1ryk9yJC7mUvV6AfmVTq._1l6ia3IeHd_H2RLat1VkKj form{display:flex;flex-flow:column wrap;align-content:stretch;height:54vh;margin:0 -15px}.I1ryk9yJC7mUvV6AfmVTq._1l6ia3IeHd_H2RLat1VkKj ._13_BpCaQbJcly46OA5etYA{margin:0 15px;width:calc(50% - 30px);flex:0 1 auto}}\n", ""]);

// Exports
exports.locals = {
	"EditGoalModal": "I1ryk9yJC7mUvV6AfmVTq",
	"goalImg": "_3EFWuAYBkNYL3V4Bjyvlnh",
	"newGoal": "_1l6ia3IeHd_H2RLat1VkKj",
	"formGroup": "_13_BpCaQbJcly46OA5etYA"
};